import JSZip from "jszip"

const SLIDE_XML_RE = /^ppt\/slides\/slide\d+\.xml$/

export const LARGE_DECK_SLIDE_THRESHOLD = 80

type ZipInput = File | Blob | ArrayBuffer | Uint8Array

export async function countPptxSlides(file: ZipInput): Promise<number | null> {
  try {
    const buffer =
      file instanceof Uint8Array || file instanceof ArrayBuffer
        ? file
        : new Uint8Array(await file.arrayBuffer())
    const zip = await JSZip.loadAsync(buffer)
    let count = 0
    zip.forEach((path) => {
      if (SLIDE_XML_RE.test(path)) count += 1
    })
    return count
  } catch {
    return null
  }
}
